import * as tslib_1 from "tslib";
import { DataSource } from '@angular/cdk/collections';
var TableDataSource = /** @class */ (function (_super) {
    tslib_1.__extends(TableDataSource, _super);
    function TableDataSource(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    TableDataSource.prototype.connect = function (collectionViewer) {
        return this.data;
    };
    TableDataSource.prototype.disconnect = function (collectionViewer) { };
    return TableDataSource;
}(DataSource));
export { TableDataSource };
//# sourceMappingURL=tableDataSource.js.map